import api from './api';

export const carryItemsService = {
  getAll: () => api.get('/carry-items'),
  create: (name) => api.post('/carry-items', { name }),
  delete: (id) => api.delete(`/carry-items/${id}`),
};
